import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";

export const getProductDiscounts = async (domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `shop/products/discounts`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}